import React, { createContext, useContext, useState, useCallback } from 'react';

/**
 * Context for sharing calendar options state between CalendarPage and Layout header.
 * This allows the three-dot menu in the header to control calendar options on mobile.
 */
const CalendarOptionsContext = createContext(null);

export function CalendarOptionsProvider({ children }) {
  const [calendarOptions, setCalendarOptions] = useState(null);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const registerCalendarOptions = useCallback((options) => {
    setCalendarOptions(options);
  }, []);

  const unregisterCalendarOptions = useCallback(() => {
    setCalendarOptions(null);
  }, []);

  const openDrawer = useCallback(() => {
    setIsDrawerOpen(true);
  }, []);

  const closeDrawer = useCallback(() => {
    setIsDrawerOpen(false);
  }, []);

  return (
    <CalendarOptionsContext.Provider
      value={{
        calendarOptions,
        registerCalendarOptions,
        unregisterCalendarOptions,
        isDrawerOpen,
        openDrawer,
        closeDrawer,
      }}
    >
      {children}
    </CalendarOptionsContext.Provider>
  );
}

export function useCalendarOptionsContext() {
  return useContext(CalendarOptionsContext);
}

export default CalendarOptionsContext;
